module.exports = __webpack_public_path__ + "static/media/persona_bg.ff4b5fe4.png";